const feedback = {
  115488721: {
    message: 'Very Very Good Job Here ',
    imageUrl: 'https://sm-assets-mt3.s3.amazonaws.com/smtheme/stock/91150b20-e796-550f-87f1-8434e43586a4.jpg',
  },
  116342808: {
    message: 'Good Job here as well',
    imageUrl:
      'https://sm-assets-mt3.s3.amazonaws.com/survey/115780210/score_feedback/f411e43c-0936-410d-be8c-f899f66f3909.png',
  },
};

export default feedback;
